import Component from "../../../../rankers/lib/component";
import stateMachine from '../instances/state_machine/index';

export default class NavComponent extends Component {

    constructor(id_or_element, config={}) {
        super({
            element: id_or_element,
            config:  config,
            stateMachine: stateMachine
        });
    }

}